/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IdNameResultOfint } from './IdNameResultOfint';
import {
    IdNameResultOfintFromJSON,
    IdNameResultOfintFromJSONTyped,
    IdNameResultOfintToJSON,
    IdNameResultOfintToJSONTyped,
} from './IdNameResultOfint';

/**
 * 
 * @export
 * @interface TuitionCalculationCandidate
 */
export interface TuitionCalculationCandidate {
    /**
     * 
     * @type {IdNameResultOfint}
     * @memberof TuitionCalculationCandidate
     */
    member: IdNameResultOfint;
    /**
     * 
     * @type {IdNameResultOfint}
     * @memberof TuitionCalculationCandidate
     */
    student: IdNameResultOfint;
    /**
     * 
     * @type {Array<IdNameResultOfint>}
     * @memberof TuitionCalculationCandidate
     */
    enrollments: Array<IdNameResultOfint>;
}

/**
 * Check if a given object implements the TuitionCalculationCandidate interface.
 */
export function instanceOfTuitionCalculationCandidate(value: object): value is TuitionCalculationCandidate {
    if (!('member' in value) || value['member'] === undefined) return false;
    if (!('student' in value) || value['student'] === undefined) return false;
    if (!('enrollments' in value) || value['enrollments'] === undefined) return false;
    return true;
}

export function TuitionCalculationCandidateFromJSON(json: any): TuitionCalculationCandidate {
    return TuitionCalculationCandidateFromJSONTyped(json, false);
}

export function TuitionCalculationCandidateFromJSONTyped(json: any, ignoreDiscriminator: boolean): TuitionCalculationCandidate {
    if (json == null) {
        return json;
    }
    return {
        
        'member': IdNameResultOfintFromJSON(json['member']),
        'student': IdNameResultOfintFromJSON(json['student']),
        'enrollments': ((json['enrollments'] as Array<any>).map(IdNameResultOfintFromJSON)),
    };
}

export function TuitionCalculationCandidateToJSON(json: any): TuitionCalculationCandidate {
    return TuitionCalculationCandidateToJSONTyped(json, false);
}

export function TuitionCalculationCandidateToJSONTyped(value?: TuitionCalculationCandidate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'member': IdNameResultOfintToJSON(value['member']),
        'student': IdNameResultOfintToJSON(value['student']),
        'enrollments': ((value['enrollments'] as Array<any>).map(IdNameResultOfintToJSON)),
    };
}

